import {NgModule} from '@angular/core';
import {NoPreloading, RouterModule, Routes} from '@angular/router';
import {ModalNavigationGuard} from './modal-navigation-guard';
import {CheckOrderGuard} from './guard/check-order-guard';

import {NAVIGATIONURLS} from './services/navigation.service';
import {PaymentSuccessPage} from './pages/payment-success/payment-success.page';

const routes: Routes = [
	{
		path: '',
		redirectTo: NAVIGATIONURLS.home(),
		pathMatch: 'full',
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.paymentCancel(),
		redirectTo: NAVIGATIONURLS.paymentCancel()
	},
	{
		path: NAVIGATIONURLS.paymentFail(),
		redirectTo: NAVIGATIONURLS.paymentFailPaymentId()
	},
	{
		path: NAVIGATIONURLS.home(),
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
		canDeactivate: [ModalNavigationGuard]
	},

	{
		path: NAVIGATIONURLS.paymentSuccess(),
		loadChildren: () => import('./pages/payment-success/payment-success.module').then(m => m.SuccessPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: PaymentSuccessPage.urlWithPaymentParam,
		loadChildren: () => import('./pages/payment-success/payment-success.module').then(m => m.SuccessPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.menu(),
		loadChildren: () => import('./pages/menu/menu.module').then(m => m.MenuPageModule),
		canActivate: [CheckOrderGuard],
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.map(),
		loadChildren: () => import('./pages/map/map.module').then(m => m.MapPageModule),
		canDeactivate: [ModalNavigationGuard]
	},

	{
		path: NAVIGATIONURLS.paymentFail(),
		loadChildren: () => import('./pages/order/order.module').then(m => m.OrderPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.paymentFail(),
		loadChildren: () => import('./pages/order/order.module').then(m => m.OrderPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.order(),
		loadChildren: () => import('./pages/order/order.module').then(m => m.OrderPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.signUp(),
		loadChildren: () => import('./pages/sign-up/sign-up.module').then(m => m.SignUpPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.signIn(),
		loadChildren: () => import('./pages/sign-in/sign-in.module').then(m => m.SignInPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	// {
	// 	path: NAVIGATIONURLS.url,
	// 	loadChildren: () => import('./pages/sign-in-order/sign-in-order.module').then(m => m.SignInOrderPageModule),
	// 	canDeactivate: [ModalNavigationGuard],
	// },
	{
		path: NAVIGATIONURLS.myOrders(),
		loadChildren: () => import('./pages/my-orders/my-orders.module').then(m => m.MyOrdersPageModule),
		// canActivate: [UserIsAnonimusGuard],
		canDeactivate: [ModalNavigationGuard]
	},
	// {
	// 	path: VenuePage.url,
	// 	loadChildren: () => import('./pages/venue/venue.module').then(m => m.VenuePageModule),
	// 	canDeactivate: [ModalNavigationGuard],
	// },
	{
		path: NAVIGATIONURLS.confirmEmail(),
		loadChildren: () =>
			import('./pages/email-confirmation/email-confirmation.module').then(m => m.EmailConfirmationPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.account(),
		loadChildren: () => import('./pages/account/account.module').then(m => m.AccountPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.impressum(),
		loadChildren: () => import('./pages/impressum/impressum.module').then(m => m.ImpressumPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.tos(),
		loadChildren: () => import('./pages/tos/tos.module').then(m => m.TosPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.privacy(),
		loadChildren: () => import('./pages/privacy/privacy.module').then(m => m.PrivacyPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.subscriptions(),
		loadChildren: () => import('./pages/subscriptions/subscriptions.module').then(m => m.SubscriptionsPageModule),
		canDeactivate: [ModalNavigationGuard]
	},
	{
		path: NAVIGATIONURLS.subscriptions(),
		loadChildren: () => import('./pages/subscriptions/subscriptions.module').then(m => m.SubscriptionsPageModule),
		canDeactivate: [ModalNavigationGuard]
	},

	{
		path: NAVIGATIONURLS.maintenance(),
		loadChildren: () => import('./pages/maintenance/maintenance.page.module').then(m => m.MaintenancePageModule)
	},
	{
		path: NAVIGATIONURLS.favourite(),
		loadChildren: () => import('./pages/favourite/favourite.module').then(m => m.FavouritePageModule)
	},
	{
		path: NAVIGATIONURLS.emailAction(),
		loadChildren: () => import('./pages/email-action/email-action.module').then(m => m.EmailActionPageModule)
	},
	{
		path: NAVIGATIONURLS.contact(),
		loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactPageModule)
	},
	{
		path: NAVIGATIONURLS.outlets(),
		loadChildren: () => import('./pages/outlets/outlets.module').then(m => m.OutletsPageModule)
	},
	{
		path: '**',
		redirectTo: '/'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {preloadingStrategy: NoPreloading})],
	exports: [RouterModule]
})
export class AppRoutingModule {}
